"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetContent = void 0;
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _components2 = require("../../../../components");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _utils = require("../../../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); } // istanbul ignore next -- lazy import
const Details = /*#__PURE__*/(0, _react.lazy)(async () => Promise.resolve().then(() => _interopRequireWildcard(require('../../../Details/Details'))));
const WidgetContent = ({
  isGallery,
  shareItemId
}) => {
  const {
    className
  } = (0, _contexts.useConfiguration)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    mediaItems
  } = (0, _contexts.useOlapicData)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    isOpenDetails,
    onOpenDetails
  } = (0, _contexts.useOlapicDetails)();
  (0, _react.useEffect)(() => {
    if (shareItemId && mediaItems.length > 0) {
      const foundItem = mediaItems.find(item => item.id === shareItemId);
      const meta = ['Olapic', 'Popup opened by shared link', foundItem?.mediaType ?? 'unknown', shareItemId, '0', foundItem?.products?.join(',') ?? ''];
      onOpenDetails(shareItemId, meta);
    }
    // eslint-disable-next-line react-compiler/react-compiler -- we need it
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to run this effect once
  }, []);
  const linkToGallery = (0, _react.useCallback)(() => {
    const eventMeta = ['Olapic', 'View all'];
    (0, _utils.createUserActionEvent)(eventMeta);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.WidgetRoot, {
      className: className,
      "data-testid": getTestId(_constants.MAIN),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
        variant: "h3",
        component: isGallery ? 'h1' : 'h2',
        align: "center",
        color: "textPrimary",
        children: translations.oriflameOnMe
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleArea, {
        align: "center",
        color: "textPrimary",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.EmphasizeText, {
          content: translations.olapic2ShareWith,
          startWith: ['@', '#']
        })
      }), isGallery ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.OlapicGallery, {}) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components2.OlapicSlider, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ViewAll, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
            variant: "outlined",
            href: "/gallery",
            "data-testid": getTestId(_constants.GALLERY_BUTTON),
            onClick: linkToGallery,
            children: translations.viewAll
          })
        })]
      })]
    }), isOpenDetails ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Details, {})
    }) : null]
  });
};
exports.WidgetContent = WidgetContent;
